aui-footer {
  display: block;
  inline-size: 100%;

  s-icon {
    font-size: 1rem;
  }
  > footer > s-container {
    max-inline-size: none;
    padding-block: var(--padding-sm);
    padding-inline: 0;
    text-align: center;

    span[data-ref='aui-footer.main-span'] * + * {
      margin-inline-start: var(--margin-lg);
    }
  }

  s-col[data-ref='aui-footer.chat-link-col'] {
    padding-block-end: var(--padding-sm);
    text-align: center;
    * + * {
      margin-inline-start: var(--margin-sm);
    }
  }

  s-dialog {
    line-height: var(--line-height-sm);

    [data-ref='cam-photo-container'] * {
      block-size: 72px;
      font-size: 3.375rem;
      inline-size: 72px;
    }
    a:hover {
      text-decoration: none;
    }
    button + button {
      margin-block: 0.1875rem;
    }
  }

  [data-ref='cam-text'] {
    inline-size: 175px;
  }
  hr {
    margin-block: var(--margin-lg);
    margin-inline: 0;
  }
  [data-ref='copyright'] {
    color: var(--color-gray-dark);
    white-space: nowrap;
  }
  /* TODO  use var(--breakpoint-sm-max) when that's supported */
  @media only screen and (max-width: 599px) {
    > footer > s-container {
      flex-direction: column;
    }
    > footer > s-container > span {
      display: block;
      margin-block-start: var(--margin-xs);
      margin-inline-start: 0;
    }
  }
  aui-sidenav & {
    block-size: 4.0625rem;

    > footer > s-container {
      display: flex;
      flex-direction: column;
      font-size: var(--font-size-xs);
      justify-content: flex-start;
      margin-block: var(--margin-sm);
      margin-inline-start: var(--margin-md);
      padding: 0;
      text-align: start;

      > span[data-ref='aui-footer.main-span'] {
        align-items: center;
        align-items: start;
        display: flex;
        flex-direction: column;
        padding-inline-end: var(--padding-sm);

        * + * {
          margin-inline-start: var(--margin-sm);
        }
        a {
          line-height: var(--line-height-xs);
        }
        button.link {
          align-items: center;
          block-size: 1.25rem;
          font-size: var(--font-size-xs);
        }
      }

      span[data-ref='copyright'] {
        margin-block-end: var(--margin-md);
        margin-inline-start: var(--margin-sm);
        padding-inline-start: 0;
      }

      [data-ref='aui-footer.avalara-dot-com'] {
        display: none;
      }
    }

    @media only screen and (max-width: 599px) {
      > footer > s-container {
        flex-direction: column;
      }
      > footer > s-container > span {
        display: block;
        margin-block-start: 0;
        margin-inline-start: 0;
      }
    }
  }

  s-popper.subnav & {
    > footer > s-container {
      background-color: var(--color-white);
      border: solid 1px var(--color-gray-light);
      border-radius: 0 4px 4px 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin-inline-start: var(--margin-md);
      padding: var(--padding-sm);
      text-align: start;

      span[data-ref='aui-footer.links-span'] {
        align-items: start;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        > button.link,
        > a {
          align-items: center;
          block-size: 2.25rem;
          border-radius: 4px;
          color: var(--color-gray-darkest);
          display: flex;
          inline-size: 100%;
          padding-block: 0;
          padding-inline: var(--padding-sm);
          vertical-align: middle;
        }
        > button.link:hover,
        > a:hover {
          background-color: var(--color-gray-lightest);
          text-decoration: none;
        }
        > button.link {
          align-items: center;
          text-align: start;
        }
      }

      span[data-ref='aui-footer.main-span'] {
        display: flex;
        flex-direction: column;
        margin-block-end: var(--margin-xs);
        * + * {
          margin-inline-start: 0;
        }

        [data-ref='aui-footer.avalara-dot-com'] {
          display: none;
        }
      }
      [data-ref='copyright'] {
        color: var(--color-gray-dark);
        display: block;
        font-size: var(--font-size-xs);
        padding-block: var(--padding-xs);
        padding-inline: var(--padding-sm);
      }
    }
  }
}

// when the dialog is rendered by the side nav, it is placed outside the scope of the footer
/* stylelint-disable selector-max-id */
s-dialog#footer-contact-dialog {
  line-height: 24px;

  [data-ref='cam-photo-container'] * {
    block-size: 72px;
    font-size: 3.375rem;
    inline-size: 72px;
  }
  a:hover {
    text-decoration: none;
  }
  button + button {
    margin-block: 0.1875rem;
  }

  [data-ref='cam-text'] {
    inline-size: 175px;
  }
}

// RTL support
[dir='rtl'] {
  // Mirror border-radius for subnav elements in RTL
  s-popper.subnav aui-footer > footer > s-container {
    border-radius: 4px 0 0 4px;
  }
}
